/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { DlmProductDto } from '../models/dlm-product-dto';
import { DlmProductDtoDlmBaseResponse } from '../models/dlm-product-dto-dlm-base-response';
import { DlmProductDtoListDlmBaseResponse } from '../models/dlm-product-dto-list-dlm-base-response';
import { DlmProductFileDto } from '../models/dlm-product-file-dto';
import { DlmProductFileDtoBaseResponse } from '../models/dlm-product-file-dto-base-response';
import { DlmProductFileDtoListBaseResponse } from '../models/dlm-product-file-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class DlmProductService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDlmProductGetProductsGet
   */
  static readonly ApiDlmProductGetProductsGetPath = '/api/DLMProduct/get-products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetProductsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<DlmProductDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetProductsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetProductsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<DlmProductDtoListDlmBaseResponse> {

    return this.apiDlmProductGetProductsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoListDlmBaseResponse>) => r.body as DlmProductDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetProductsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<DlmProductDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetProductsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetProductsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<DlmProductDtoListDlmBaseResponse> {

    return this.apiDlmProductGetProductsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoListDlmBaseResponse>) => r.body as DlmProductDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductGetProductGet
   */
  static readonly ApiDlmProductGetProductGetPath = '/api/DLMProduct/get-product';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetProductGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductGet$Plain$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetProductGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetProductGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductGet$Plain(params?: {
    productId?: number;
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductGetProductGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetProductGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductGet$Json$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetProductGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetProductGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetProductGet$Json(params?: {
    productId?: number;
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductGetProductGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductAddProductPost
   */
  static readonly ApiDlmProductAddProductPostPath = '/api/DLMProduct/add-product';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductAddProductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductAddProductPost$Plain$Response(params?: {
    setGeneratedPartNumber?: boolean;
    uniqueCompanyId?: number;
    body?: DlmProductDto
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductAddProductPostPath, 'post');
    if (params) {
      rb.query('setGeneratedPartNumber', params.setGeneratedPartNumber, {});
      rb.query('uniqueCompanyId', params.uniqueCompanyId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductAddProductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductAddProductPost$Plain(params?: {
    setGeneratedPartNumber?: boolean;
    uniqueCompanyId?: number;
    body?: DlmProductDto
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductAddProductPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductAddProductPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductAddProductPost$Json$Response(params?: {
    setGeneratedPartNumber?: boolean;
    uniqueCompanyId?: number;
    body?: DlmProductDto
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductAddProductPostPath, 'post');
    if (params) {
      rb.query('setGeneratedPartNumber', params.setGeneratedPartNumber, {});
      rb.query('uniqueCompanyId', params.uniqueCompanyId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductAddProductPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductAddProductPost$Json(params?: {
    setGeneratedPartNumber?: boolean;
    uniqueCompanyId?: number;
    body?: DlmProductDto
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductAddProductPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductEditProductPut
   */
  static readonly ApiDlmProductEditProductPutPath = '/api/DLMProduct/edit-product';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductEditProductPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductEditProductPut$Plain$Response(params?: {
    body?: DlmProductDto
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductEditProductPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductEditProductPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductEditProductPut$Plain(params?: {
    body?: DlmProductDto
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductEditProductPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductEditProductPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductEditProductPut$Json$Response(params?: {
    body?: DlmProductDto
  }): Observable<StrictHttpResponse<DlmProductDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductEditProductPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductEditProductPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductEditProductPut$Json(params?: {
    body?: DlmProductDto
  }): Observable<DlmProductDtoDlmBaseResponse> {

    return this.apiDlmProductEditProductPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductDtoDlmBaseResponse>) => r.body as DlmProductDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductArchiveProductPut
   */
  static readonly ApiDlmProductArchiveProductPutPath = '/api/DLMProduct/archive-product';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductArchiveProductPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductArchiveProductPut$Plain$Response(params?: {
    productId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductArchiveProductPutPath, 'put');
    if (params) {
      rb.query('productId', params.productId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductArchiveProductPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductArchiveProductPut$Plain(params?: {
    productId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiDlmProductArchiveProductPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductArchiveProductPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductArchiveProductPut$Json$Response(params?: {
    productId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductArchiveProductPutPath, 'put');
    if (params) {
      rb.query('productId', params.productId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductArchiveProductPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductArchiveProductPut$Json(params?: {
    productId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiDlmProductArchiveProductPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductGetFilesGet
   */
  static readonly ApiDlmProductGetFilesGetPath = '/api/DLMProduct/get-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetFilesGet$Plain$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<DlmProductFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetFilesGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetFilesGet$Plain(params?: {
    productId?: number;
  }): Observable<DlmProductFileDtoListBaseResponse> {

    return this.apiDlmProductGetFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoListBaseResponse>) => r.body as DlmProductFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductGetFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetFilesGet$Json$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<DlmProductFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductGetFilesGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductGetFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductGetFilesGet$Json(params?: {
    productId?: number;
  }): Observable<DlmProductFileDtoListBaseResponse> {

    return this.apiDlmProductGetFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoListBaseResponse>) => r.body as DlmProductFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductUploadFileProductIdPost
   */
  static readonly ApiDlmProductUploadFileProductIdPostPath = '/api/DLMProduct/upload-file/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductUploadFileProductIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDlmProductUploadFileProductIdPost$Plain$Response(params: {
    productId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductUploadFileProductIdPostPath, 'post');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductUploadFileProductIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDlmProductUploadFileProductIdPost$Plain(params: {
    productId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductUploadFileProductIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductUploadFileProductIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDlmProductUploadFileProductIdPost$Json$Response(params: {
    productId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductUploadFileProductIdPostPath, 'post');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductUploadFileProductIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDlmProductUploadFileProductIdPost$Json(params: {
    productId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductUploadFileProductIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductUpdateFilePost
   */
  static readonly ApiDlmProductUpdateFilePostPath = '/api/DLMProduct/update-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductUpdateFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductUpdateFilePost$Plain$Response(params?: {
    body?: DlmProductFileDto
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductUpdateFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductUpdateFilePost$Plain(params?: {
    body?: DlmProductFileDto
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductUpdateFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductUpdateFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductUpdateFilePost$Json$Response(params?: {
    body?: DlmProductFileDto
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductUpdateFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDlmProductUpdateFilePost$Json(params?: {
    body?: DlmProductFileDto
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductUpdateFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDlmProductDownloadFileFileIdGet
   */
  static readonly ApiDlmProductDownloadFileFileIdGetPath = '/api/DLMProduct/download-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductDownloadFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDownloadFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductDownloadFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductDownloadFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDownloadFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiDlmProductDownloadFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiDlmProductDeleteFileFileIdDelete
   */
  static readonly ApiDlmProductDeleteFileFileIdDeletePath = '/api/DLMProduct/delete-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductDeleteFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDeleteFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductDeleteFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDeleteFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductDeleteFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDlmProductDeleteFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDeleteFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<DlmProductFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DlmProductService.ApiDlmProductDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DlmProductFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDlmProductDeleteFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDlmProductDeleteFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<DlmProductFileDtoBaseResponse> {

    return this.apiDlmProductDeleteFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DlmProductFileDtoBaseResponse>) => r.body as DlmProductFileDtoBaseResponse)
    );
  }

}
